import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { ProblemIntro } from './components/ProblemIntro';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { SystemFeatures } from './components/SystemFeatures';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { AboutKarito } from './components/AboutKarito';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full overflow-x-hidden bg-ink-950" data-id="element-0" data-mp="23t8heerpojdg">
      <MetaPixel data-id="element-1" data-mp="3iiwdijzxza14" />
      <main data-id="element-2" data-mp="3ijfwm41bw4gq">
        <Hero data-id="element-3" data-mp="3ijpcuzwkmx98" />
        <StatsBar data-id="element-4" data-mp="3ii4sg33z0up3" />
        <ProblemIntro data-id="element-5" data-mp="3mlavz2zp87rv" />
        <BeforeAfter data-id="element-6" data-mp="3mkrgdsxitvh0" />
        <PainPoints data-id="element-7" data-mp="3mjzs7369700r" />
        <SystemFeatures data-id="element-8" data-mp="3mjg7xft4rzjk" />
        <Volumes data-id="element-9" data-mp="3rcj6y3gog175" />
        <Bonuses data-id="element-10" data-mp="3rbzmaezn6ypf" />
        <Offer data-id="element-11" data-mp="3rdkisa5iorpx" />
        <Guarantee data-id="element-12" data-mp="3rd1bdndhtlq5" />
        <Testimonials data-id="element-13" data-mp="3relumgucxi8p" />
        <AboutKarito data-id="element-14" data-mp="5os92t1uy7l" />
        <Faq data-id="element-15" data-mp="4wvhonpuufq" />
        <FinalCta data-id="element-16" data-mp="4n725ibkvc5" />
      </main>
      <Footer data-id="element-17" data-mp="7su7f7e1n58" />
      <FloatingCta data-id="element-18" data-mp="2zl3cjn8vpa6d" />
      <PurchasePopup data-id="element-19" data-mp="2zllijblcf2rh" />
    </div>;
}